<div class="fleetcard-application-nudge-banner success">
  <div class="content">
    <strong>{{header}} &nbsp;&nbsp;</strong>
    <span [class.link]="messageType === fleetCardsApplicationNudgeMessageType.linkBankAccount"
    (click)="handlePlaidLinkClick()">{{body}}</span>&nbsp;&nbsp;
    <button
      phx-button
      [phxButtonRole]="'primary'"
      [phxButtonType]="'default'"
      [phxBackground]="'bold'"
      [phxSize]="'small'"
      (phxOnClick)="handleCTAClick()"
    >
      {{btnText}}
    </button>
  </div>
  <div class="close" (click)="closeBanner()"></div>
</div>